export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_FAILURE = 'USER_REGISTRATION_FAILURE';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAILURE = 'USER_DETAILS_FAILURE';
export const MODULE_LIST_SUCCESS = 'MODULE_LIST_SUCCESS';
export const MODULE_LIST_FAILURE = 'MODULE_LIST_FAILURE';
export const RESET_USER_DETAILS = 'RESET_USER_DETAILS';
